import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'pcln-design-system'
import { canUseDOM } from 'exenv'
import { head, join, map, pipe, split } from 'ramda'

const PostLoadWebFontsThemeProvider = ({ fontSettings, ...props }) => {
  const config = {
    google: {
      families: fontSettings
    }
  }

  const defaultFonts = "'Helvetica Neue', Helvetica, Arial, sans-serif"
  const customFonts = join(', ', map(pipe(split(':'), head), fontSettings))
  const finalFonts = `${customFonts}, ${defaultFonts}`

  const [ fonts, setFonts ] = useState(defaultFonts)
  const activateFonts = (status) => {
    if (status === 'active') {
      setFonts(finalFonts)
    }
  }

  if (canUseDOM) {
    const WebFontLoader = require('@dr-kobros/react-webfont-loader').default
    return (
      <WebFontLoader config={config} onStatus={activateFonts}>
        <ThemeProvider theme={{ font: fonts }} {...props} />
      </WebFontLoader>
    )
  } else {
    return (<ThemeProvider theme={{ font: fonts }} {...props} />)
  }
}

PostLoadWebFontsThemeProvider.propTypes = {
  fontSettings: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default PostLoadWebFontsThemeProvider
